import processing from './modules/processing';
import checklist from './modules/checklist';

export default [processing, checklist];
